import React from 'react'
import { isEmpty } from 'lodash'
import SearchableServiceTxnListViewContainer from '../../components/SearchableServiceTxnListViewContainer'

export default ({ isShow, onHide, recentlyServiceTxns, onServiceTxnClick }) => {
  if (!isShow) return null

  return (
    <div>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-50"
        onClick={onHide}
      />

      {/* Dialog */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-xl max-w-5xl w-full max-h-[85vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">
              Guest Privilege
            </h2>
            <button
              onClick={onHide}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="p-6 overflow-y-auto max-h-[calc(85vh-140px)]">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Recently Check-Ins */}
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Recently Check-Ins
                </h3>
                <div className="space-y-2">
                  {renderRecentlyServiceTxns(
                    recentlyServiceTxns,
                    onServiceTxnClick,
                  )}
                </div>
              </div>

              {/* Search Check-Ins */}
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Search Check-Ins
                </h3>
                <SearchableServiceTxnListViewContainer
                  onServiceTxnSelect={onServiceTxnClick}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const renderRecentlyServiceTxns = (recentlyServiceTxns, onServiceTxnClick) => {
  if (isEmpty(recentlyServiceTxns))
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <svg
          className="w-12 h-12 text-gray-300 mb-3"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        <p className="text-gray-500 text-sm">No recently check-ins</p>
      </div>
    )

  return recentlyServiceTxns.map((recentlyServiceTxn) => (
    <ServiceTxnListItem
      key={recentlyServiceTxn._id}
      serviceTxn={recentlyServiceTxn}
      onClick={() => onServiceTxnClick(recentlyServiceTxn)}
    />
  ))
}

const ServiceTxnListItem = ({ serviceTxn, onClick }) => (
  <button
    onClick={onClick}
    className="w-full bg-white border border-gray-200 rounded-lg p-4 hover:border-primary-500 hover:shadow-md transition-all text-left group"
  >
    <div className="flex items-center justify-between">
      <div className="flex-1">
        <p className="text-gray-900 font-medium mb-1">
          {serviceTxn.reservation.mainPax.fullName}
        </p>
        <p className="text-gray-500 text-sm">
          {serviceTxn.reservation.confirmationNumber}
        </p>
      </div>
      <div className="flex-shrink-0 ml-4">
        <p className="text-gray-400 text-sm">
          {serviceTxn.serviceInfo.inTime.fromNow()}
        </p>
      </div>
    </div>
  </button>
)
